import { localStorageHandler } from 'core/services';
import packageJSON from '../../../package.json';
import _ from 'lodash';

export default async function checkBuildVersion() {
	return _.throttle(async () => {
		const appVersion = localStorageHandler.get('appVersion');
		const newVersion = packageJSON.version;
		if (newVersion != null && appVersion !== newVersion) {
			location.reload();
		}
		localStorageHandler.set('appVersion', newVersion);
	}, 60000);
}
